import { STORAGE_ASSETS_LINK, URLS } from '../constant/constant';
import { API_PREFIX, GRAPHQL_PREFIX } from './global';

interface Urls {
    DoctorsApi: string;
    DoctorCertificatesApi: string;
    NewsApi: string;
    SpecialityApi: string;
    IndexesApi: string;
    TestimonialApi: string;
    UserApi: string;
    AuthApi: string;
    PatientApi: string;
    TrackMyRequestApi: string;
    CountryApi: string;
    MessageApi: string;
    AccountsApi: string;
    ReferralApi: string;
    TermsAndConditionsApi: string;
    PatientAccountApi: string;
    ScheduleApi: string;
    AppointmentApi: string;
    ZoomApi: string;
    PrescriptionApi: string;
    ResetPasswordApi: string;
    OtherMedicalApi: string;
    OtherMedicalReferralApi: string;
    AdminApis: string;
    RefferalDiscountApi: string;
    AppVersionApi: string;
    PatientViewMsgCenterApi: string;
    PackageAPI: string;
    StorageAssetsApi: string;
    VendorApi: string;
    SupportApi: string;
    VendorsApi: string;
    GraphQL: string;
    ProviderMetadataApi: string;
    ProviderApi: string;
}

export class RestApi {
    public static Urls: Urls = {
        DoctorsApi: URLS.API_BASE_URL + API_PREFIX + 'doctors/',
        DoctorCertificatesApi: URLS.API_BASE_URL + API_PREFIX + 'doctors/certificates/',
        NewsApi: URLS.API_BASE_URL + API_PREFIX + 'news/',
        SpecialityApi: URLS.API_BASE_URL + API_PREFIX + 'specialty/',
        IndexesApi: URLS.API_BASE_URL + API_PREFIX + 'indexes/',
        TestimonialApi: URLS.API_BASE_URL + API_PREFIX + 'testimonial/',
        UserApi: URLS.API_BASE_URL + API_PREFIX + 'user/',
        AuthApi: URLS.API_BASE_URL + API_PREFIX + 'auth/',
        PatientApi: URLS.API_BASE_URL + API_PREFIX + 'patient/',
        TrackMyRequestApi: URLS.API_BASE_URL + API_PREFIX + 'TrackMyRequest/',
        CountryApi: URLS.API_BASE_URL + API_PREFIX + 'country/',
        MessageApi: URLS.API_BASE_URL + API_PREFIX + 'messages/',
        AccountsApi: URLS.API_BASE_URL + API_PREFIX + 'accounts/',
        ReferralApi: URLS.API_BASE_URL + API_PREFIX + 'referral/',
        TermsAndConditionsApi: URLS.API_BASE_URL + API_PREFIX + 'terms/',
        PatientAccountApi: URLS.API_BASE_URL + API_PREFIX + 'patientaccount/',
        ScheduleApi: URLS.API_BASE_URL + API_PREFIX + 'schedule/',
        AppointmentApi: URLS.API_BASE_URL + API_PREFIX + 'appointment/',
        ZoomApi: URLS.API_BASE_URL + API_PREFIX + 'zoom/',
        PrescriptionApi: URLS.API_BASE_URL + API_PREFIX + 'prescription/',
        ResetPasswordApi: URLS.API_BASE_URL + API_PREFIX + 'userpassword/',
        OtherMedicalApi: URLS.API_BASE_URL + API_PREFIX + 'othermedical/',
        OtherMedicalReferralApi: URLS.API_BASE_URL + API_PREFIX + 'referral/othermedical/',
        AdminApis: URLS.API_BASE_URL + API_PREFIX + 'admin/',
        RefferalDiscountApi: URLS.API_BASE_URL + API_PREFIX + 'admin/discounts/',
        AppVersionApi: URLS.API_BASE_URL + API_PREFIX + 'health/',
        PatientViewMsgCenterApi: URLS.API_BASE_URL + API_PREFIX + 'messages/',
        PackageAPI: URLS.API_BASE_URL + API_PREFIX + 'package/',
        StorageAssetsApi: STORAGE_ASSETS_LINK,
        VendorApi: URLS.API_BASE_URL + API_PREFIX + 'vendor/',
        SupportApi: URLS.API_BASE_URL + API_PREFIX + 'support/',
        VendorsApi: URLS.API_BASE_URL + API_PREFIX + 'vendors/',
        ProviderMetadataApi: URLS.API_BASE_URL + API_PREFIX + 'ProviderMetadata/',
        ProviderApi: URLS.API_BASE_URL + API_PREFIX + 'provider/',
        GraphQL: URLS.API_BASE_URL + GRAPHQL_PREFIX
    };
}
